import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {ViewType} from "../../view_type/ViewType";
import {hitGoogleTagManager} from "./init_google_tag_manager";

const event = "modal_detail";

const tabsMap: Record<OfferModalActiveTab, string> = {
    [OfferModalActiveTab.GALLERY]: "galeria",
    [OfferModalActiveTab.CONSTRUCTION_GALLERY]: "zdjęcia z budowy",
    [OfferModalActiveTab.MAP]: "mapa",
    [OfferModalActiveTab.PLAN]: "plan"
};

export const gtmOfferGalleryEvents = {
    onGalleryTabClick: (tab: OfferModalActiveTab) => {
        const gtmData = {
            event,
            event_category: tabsMap[tab],
            event_action: "click",
            event_label: "detailed_tab"
        };

        hitGoogleTagManager(gtmData);
    },
    onOfferGalleryModalOpen: (tab: OfferModalActiveTab, viewType: ViewType | null) => {
        const gtmData = {
            event,
            event_category: tabsMap[tab],
            event_action: "click",
            event_label: viewType === ViewType.PROPERTY ? "property" : "invest"
        };

        hitGoogleTagManager(gtmData);
    },
    onConstructionGalleryCTA: (action: "click" | "view") => {
        const gtmData = {
            event,
            event_category: "zdjęcia z budowy",
            event_action: action,
            event_label: "galeria"
        };

        hitGoogleTagManager(gtmData);
    }
};
import {OfferModalActiveTab} from "../../offer/types/OfferModalActiveTab";
import {ViewType} from "../../view_type/ViewType";
import {hitGoogleTagManager} from "./init_google_tag_manager";

const event = "modal_detail";

const tabsMap: Record<OfferModalActiveTab, string> = {
    [OfferModalActiveTab.GALLERY]: "galeria",
    [OfferModalActiveTab.CONSTRUCTION_GALLERY]: "zdjęcia z budowy",
    [OfferModalActiveTab.MAP]: "mapa",
    [OfferModalActiveTab.PLAN]: "plan"
};

export const gtmOfferGalleryEvents = {
    onGalleryTabClick: (tab: OfferModalActiveTab) => {
        const gtmData = {
            event,
            event_category: tabsMap[tab],
            event_action: "click",
            event_label: "detailed_tab"
        };

        hitGoogleTagManager(gtmData);
    },
    onOfferGalleryModalOpen: (tab: OfferModalActiveTab, viewType: ViewType | null) => {
        const gtmData = {
            event,
            event_category: tabsMap[tab],
            event_action: "click",
            event_label: viewType === ViewType.PROPERTY ? "property" : "invest"
        };

        hitGoogleTagManager(gtmData);
    },
    onConstructionGalleryCTA: (action: "click" | "view") => {
        const gtmData = {
            event,
            event_category: "zdjęcia z budowy",
            event_action: action,
            event_label: "galeria"
        };

        hitGoogleTagManager(gtmData);
    }
};
